import { useContext, useState } from "react";
import NetworkError from "../../components/NetworkError";
import { config } from "../../constants/config";
import { useEffect } from "react";
import Preloader from "../../components/Preloader";
import UserContext from "../../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import PaginationSelect from "../../components/sPaginationSelect";
import Connexion from "../../components/connexions/connexion";



export default function Connexions() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [connexions, setConnexions] = useState([]);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');
    const [nbpage, setNbpage] = useState(1);
    const [page, setPage] = useState(0);
    const [currentpage, setCurrentpage] = useState('');

    const getListConnexions = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/connections?limit=${config.secure.limit50}&page=${p + 1}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setNbpage(data?.body?.pages);

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            if (element.ident !== "profilsuperadmin") {
                                clientarraydata.push({ ...element });
                            }
                        });

                        // console.log("liste in data", clientarray)
                        // setConnexions(clientarray);
                        if (user?.isFullAction) {
                            setConnexions(clientarray);
                        } else {
                            setConnexions(clientarraydata);
                        }

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const autoSearchConnexion = async (c) => {

        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.secure.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/connections?crit=${c}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];
    
                            clientarray = data?.body?.data;
                            setNbpage(data?.body?.pages);
    
                            let clientarraydata = [];
                            await clientarray.forEach(element => {
                                if (element.ident !== "profilsuperadmin") {
                                    clientarraydata.push({ ...element });
                                }
                            });

                            // console.log("liste in data", clientarray)
                            if (user?.isFullAction) {
                                setConnexions(clientarray);
                            } else {
                                setConnexions(clientarraydata);
                            }

                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getListConnexions(page);
        } else {
            setIsSearch(false);
            getListConnexions(page);
        }
    }


    // comportements
    useEffect(() => {
        getListConnexions(page);
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchConnexion(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-4 font-weight-bold text_primary">Connexions</h1>
                <div className="row">
                    <div className="col-md-2 mb-3">
                        <PaginationSelect nbpage={nbpage} getList={getListConnexions} page={page} setPage={setPage} current={currentpage} setCurrent={setCurrentpage} />
                    </div>
                    <div className="col-md-10 mb-3">
                        {/* <Search 
                                        chaine={chaine}
                                        setChaine={setChaine}
                                        // search={searchEmployee}
                                        placeholder="Rechercher une connexion..."
                                    /> */}
                    </div>
                    <div className="col-md-12">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                {/* <Link to="/new-user" data-toggle="tooltip" title="Nouvel utilisateur" data-placement="left" className="btn-shadow ml-3 btn btn-primary btn-sm float-right">
                                                <i className="fa fa-plus mr-1"></i> <span>Nouvel utilisateur</span>
                                            </Link> */}
                                <h6 className="m-0 ">List of connexions</h6>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive mb-3">
                                    <table className="mb-0 table table-bordered">
                                        <thead className="bg-primary">
                                            <tr className="bg-primary text-white">
                                                <th className="text-center">#</th>
                                                <th>Account</th>
                                                <th>Profil</th>
                                                {/* <th>Workspace</th> */}
                                                {/* <th>Terminal</th> */}
                                                <th>IP Adress</th>
                                                <th>State</th>
                                                {/* <th>Date de connexion</th> */}
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(connexions.length === 0) && <tr style={{ borderStyle: "none" }}>
                                                <th colSpan={6} className="text-center">No connexion found</th>
                                            </tr>}
                                            {
                                                (connexions.length > 0) && connexions?.map((item, index) => (
                                                    <Connexion connexion={item} position={(config.secure.limit50 * page) + index} key={index} />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {/* <Pagination table={"client"} getList={getListConnexions} page={page} setPage={setPage} /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )

}